// src/Apps/App1.jsx
export default function Fractalizate() {
  return (
    <iframe
      src={process.env.REACT_APP_APP2_URL}
      title="Fractalízate"
      style={{ width: "100%", height: "100vh", border: "none" }}
      allow="clipboard-write"
    />
  );
}